module.exports = __webpack_public_path__ + "static/img/bg_top.db952a2a.png";